module.exports = __webpack_public_path__ + "img/landing@2x.32cc1dc7.jpg";